import React from "react";
import { Button } from "@chakra-ui/react";
import { MdOutlineEmail } from "react-icons/md";
import { AiFillFacebook, AiFillGithub, AiFillInstagram, AiFillLinkedin, AiFillTwitterCircle, AiOutlineArrowRight } from "react-icons/ai";
import { BsTelegram } from "react-icons/bs";
import { FaDiscord } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import "./Contact.css";

export type Contact = {
  name: string,
  info: string,
  icon: React.ReactElement,
  url: string,
}

export const contacts: Contact[] = [
  {
    name: "EMAIL:",
    info: "kiettran1618@gmail.com",
    icon: <MdOutlineEmail className="contact-icon" />,
    url: "mailto:kiettran1618@gmail.com",
  },
  {
    name: "FACEBOOK:",
    info: "Kiet Tran",
    icon: <AiFillFacebook className="contact-icon" />,
    url: "https://www.facebook.com/kiettran1618",
  },
  {
    name: "LINKEDIN:",
    info: "Kiet Tran",
    icon: <AiFillLinkedin className="contact-icon" />,
    url: "https://www.linkedin.com/in/kiet1618/",
  }
  ,
  {
    name: "TWITTER:",
    info: "@kiettran1618",
    icon: <AiFillTwitterCircle className="contact-icon" />,
    url: "https://twitter.com/kiettran1618",
  },
  {
    name: "GitHub:",
    info: "@kiet1618",
    icon: <AiFillGithub className="contact-icon" />,
    url: "https://github.com/kiet1618",
  },
  {
    name: "TELEGRAM:",
    info: "@kiettran1618",
    icon: <BsTelegram className="contact-icon" />,
    url: "https://t.me/kiettran1618",
  },
  {
    name: "DISCORD:",
    info: "kiet#0388",
    icon: <FaDiscord className="contact-icon" />,
    url: "https://discord.com/users/775249998379614238",
  },
  {
    name: "Instagram:",
    info: "kiettran1618",
    icon: <AiFillInstagram className="contact-icon" />,
    url: "https://www.instagram.com/kiettran1618/"

  }
];

const Contact = () => {
  return (
    <div className="bg-contact">
      <div className="contact-header">
        <p className="heading">Contact Me</p>
        <p className="text">If you have any questions or want to hire me, please contact me:</p>
      </div>

      <div className="contact-grid">
        {contacts.map((contact: Contact) => {
          return (
            <a key={uuidv4()} href={contact.url} target="_blank" rel="noreferrer">
              <div className="contact-section">
                {contact.icon}
                <div className="contact-text-div">
                  <p className="contact-title">{contact.name}</p>
                  <p className="contact-details">{contact.info}</p>
                </div>
              </div>
            </a>
          );
        })}
      </div>

      <div className="button-container">
        <a href="https://www.topcv.vn/xem-cv/DwcAVARSBAICUA4HUAACAAIMA1RSD1QBBlBQUw60d9" target="_blank">
          <Button size='lg' rightIcon={<AiOutlineArrowRight />} colorScheme="blue" variant='solid' className="contact-btn">
            Resume
          </Button>
        </a>
      </div>
    </div>
  );
};

export default Contact;
